// extracted by mini-css-extract-plugin
export default {"container":"ep-z","brandName":"fp-z","productName":"gp-z","productNamePdpEnhancements":"hp-z","breakLongProductName":"ip-z"};